import { useEffect, useMemo, useState } from "react";
import { Input } from "reactstrap";
import Popup from "./Popup";
import Label from "./Label";
import LinkType from "../enums/LinkType";

const EditLinkImprezy = ({ link, cancel, handleSave }) => {
  const linkTypeOptions = useMemo(() => {
    return Object.keys(LinkType)
      .map((key) => Number(key))
      .sort((a, b) => a - b)
      .map((key) => ({
        value: key,
        label: LinkType[key].description,
        lineNumber: LinkType[key].lineNumber
      }));
  }, []);

  const [imprezaId, setImprezaId] = useState(link?.Impreza_Id ?? '');
  const [name, setName] = useState(link?.Nazwa ?? '');
  const [url, setUrl] = useState(link?.Url ?? '');
  const [linkType, setLinkType] = useState(link?.LinkType ?? 2);
  const [lineNumber, setLineNumber] = useState(link?.LineNumber ?? LinkType[link?.LinkType ?? 2]?.lineNumber ?? 2);

  useEffect(() => {
    setImprezaId(link?.Impreza_Id ?? '');
    setName(link?.Nazwa ?? '');
    setUrl(link?.Url ?? '');
    setLinkType(link?.LinkType ?? 2);
    setLineNumber(link?.LineNumber ?? LinkType[link?.LinkType ?? 2]?.lineNumber ?? 2);
  }, [link]);

  const onLinkTypeChange = (value) => {
    const numericValue = Number(value);
    setLinkType(numericValue);
    setLineNumber(LinkType[numericValue]?.lineNumber ?? numericValue);
  };

  const submit = () => {
    const isNewLink = link?.__isNew === true;
    handleSave({
      Impreza_Id: Number(imprezaId) > 0 ? imprezaId : '',
      Nazwa: name,
      Url: url,
      LineNumber: lineNumber,
      LinkType: linkType,
      OriginalImpreza_Id: isNewLink ? '' : (link?.Impreza_Id ?? ''),
      OriginalLinkType: isNewLink ? '' : (link?.LinkType ?? ''),
      OriginalLineNumber: isNewLink ? '' : (link?.LineNumber ?? '')
    });
  };

  return (
    <Popup
      cancel={cancel}
      title={link?.__isNew ? 'Dodaj link imprezy' : 'Edytuj link imprezy'}
      submit={submit}
      showSubmit={true}
    >
      <div className="impreza-details-group">
        <Label>Nazwa</Label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="off"
        />
        <Label>Url</Label>
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          autoComplete="off"
        />
        <Label>LinkType</Label>
        <Input
          type="select"
          value={linkType}
          onChange={(e) => onLinkTypeChange(e.target.value)}
        >
          {linkTypeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        <Label>LineNumber</Label>
        <Input
          type="number"
          value={lineNumber}
          onChange={(e) => setLineNumber(e.target.value)}
        />
      </div>
    </Popup>
  );
};

export default EditLinkImprezy;
